import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { backgroundNavbar } from './style';
import { Navbar } from 'react-bootstrap';

const NavBarBaca = ({fungsinya}) => {
  return (
    <Navbar collapseOnSelect className={backgroundNavbar} style={{paddingTop: '0px'}}>
      <div className="logo">
      <Navbar.Brand href="#" onClick={fungsinya} className="pojokKiri">
      Ace Latif
    </Navbar.Brand>
    </div>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        
      </Navbar.Collapse>
    </Navbar>
  );
};
export default NavBarBaca;
